import { render, staticRenderFns } from "./ListPropertyPage.vue?vue&type=template&id=66d6ccb0&"
import script from "./ListPropertyPage.vue?vue&type=script&lang=js&"
export * from "./ListPropertyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports